var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.51,
    height: 78.51,
    viewBox: "0 0 78.51 78.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-610.475 -318.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M688.485,386.16v7.27a2.8,2.8,0,0,1-2.8,2.8H613.775a2.8,2.8,0,0,1-2.8-2.8V321.52a2.8,2.8,0,0,1,2.8-2.8h7.261a2.8,2.8,0,0,1,2.8,2.8v61.84h61.851A2.8,2.8,0,0,1,688.485,386.16Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.815,344.191l-24.31,24.319a2.8,2.8,0,0,1-3.96,0l-4.56-4.56-2.56-2.56-4.37-4.37-4.96,4.953a2.8,2.8,0,0,1-3.958,0L631,356.831a2.8,2.8,0,0,1,0-3.961l4.957-4.95,7.12-7.119a2.8,2.8,0,0,1,3.96,0l7.11,7.118,4.38,4.37L675.717,335.1a2.8,2.8,0,0,1,3.958,0l5.139,5.134A2.8,2.8,0,0,1,684.815,344.191Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIcon);
export default __webpack_public_path__ + "static/media/trending-icon.f5af3d2fc864da3eec56ee600e10f09e.svg";
export { ForwardRef as ReactComponent };